// Wells Telemetry metric config (Phase 6). Single source of truth for display,
// chart axis labels, and CSV export columns — imported by both the React
// dashboard and the backend export composer. Keep this file pure data + types
// so it can be imported on either side without pulling in a runtime dependency
// (same discipline as issue-templates.ts).
//
// DELIBERATELY NO min/max bounds. Range/bounds checking on readings is out of
// scope for this phase: ingest validates type and shape only, and any
// well-formed reading is stored and charted. This is a design decision, not an
// oversight — outlier handling is a candidate for future portal-improvement
// work. Do not add bounds here without revisiting that decision.
export const METRICS = {
    temperature: {
        key: 'temperature',
        column: 'temperature',
        label: 'Temperature',
        unit: '°C', // PENDING: awaiting Raptor confirmation
        precision: 1,
        charted: true,
        exported: true,
    },
    pressure: {
        key: 'pressure',
        column: 'pressure',
        label: 'Pressure',
        unit: 'psi', // PENDING: awaiting Raptor confirmation
        precision: 0,
        charted: true,
        exported: true,
    },
    qAnalytics: {
        key: 'qAnalytics',
        column: 'q_analytics',
        // Stored from day one but not displayed or exported until Raptor confirms
        // it should be. Flip charted/exported to true once confirmed.
        label: 'Q Analytics',
        unit: 'AU', // PENDING: awaiting Raptor confirmation (arbitrary units placeholder)
        precision: 2,
        charted: false,
        exported: false,
    },
};
//# sourceMappingURL=metrics.js.map